// Course links open the relevant experiment; the Labs menu still offers all of them.
export const learningLabTargets = {
  "bond-basics": { group: "products", lab: "bonds" },
  "bond-yields": { group: "products", lab: "bonds" },
  "duration-risk": { group: "products", lab: "bonds" },
  "tracking-difference": { group: "products", lab: "tracking" },
  "leveraged-etfs": { group: "products", lab: "leverage" },
  "dca-mechanics": { group: "investing", lab: "purchase" },
  "lump-sum-timing": { group: "investing", lab: "purchase" },
  "fund-fees": { group: "investing", lab: "fees" },
  "fee-compounding": { group: "investing", lab: "fees" },
  "retirement-planning": { group: "investing", lab: "withdrawal" },
  "diversification": { group: "risk", lab: "correlation" },
  "correlation-risk": { group: "risk", lab: "correlation" },
  "risk-drawdown": { group: "risk", lab: "drawdown" },
  "volatility-risk": { group: "risk", lab: "drawdown" },
  "sharpe-ratio": { group: "risk", lab: "sharpe" },
};
